










































import { Component, Vue } from 'vue-property-decorator';
import * as api from '@/api';
import { OncallRulesTable } from '@/config/map.conf';
import AddRuleModal from '../components/modals/addRuleModal.vue';
@Component({
    components: {
        AddRuleModal
    }
})
export default class OncallRules extends Vue {
    tableList: CommonTypes.mapObject[] = OncallRulesTable;
    rulesDataMap: CommonTypes.mapObject = {
        normal: []
        // special: []
    };
    ruleData: CommonTypes.mapObject = {};

    tableLoading: boolean = false;
    showModal: boolean = false;
    modalType: 'add' | 'update' = 'add';
    ruleDateType: 'special' | 'normal' = 'normal';
    created() {
        this.getRules();
    }
    onAddRule(ruleDateType) {
        this.ruleData = this.formatTableData({});
        this.ruleDateType = ruleDateType;
        this.modalType = 'add';
        this.showModal = true;
    }
    async getRules(type?: 'SPECIAL' | 'NORMAL') {
        this.tableLoading = true;
        try {
            const res = await api.oncallApi.getRgRules({
                rgId: this.rgId,
                ruleDateType: type ? [type] : null
            });
            const { data, code } = res;
            if (code === 200 && data) {
                if (type) {
                    this.rulesDataMap[type.toLowerCase()] = (data[type.toLowerCase()] || []).map(item => this.formatTableData(item));
                } else {
                    // this.rulesDataMap.special = (data.special || []).map(item => this.formatTableData(item));
                    this.rulesDataMap.normal = (data.normal || []).map(item => this.formatTableData(item));
                }
                this.tableLoading = false;
            }
        } catch (e) {
            this.tableLoading = false;
            console.log(e);
        }
    }
    getDisplayMember(row) {
        return `${
            row.oncallType === 'BY_USERNAME'
                ? row.oncallUser?.map(item => `${item.displayName}/${item.identify}`).join('，')
                : row.oncallGroup?.map(item => item?.displayName).join('，')
        }`;
    }
    formatTableData(rule) {
        return {
            ...rule,
            cycleType: rule.cycleType || 'BY_DAY',
            shiftType: rule.shiftType || 'WHOLE_DAY',
            oncallType: rule.oncallType || 'BY_USERNAME',
            ruleType: rule.ruleType || 'FIXED_RULE',
            // 轮流值班默认选择全周
            dayOfWeek: rule.dayOfWeek || [1, 2, 3, 4, 5, 6, 7],
            // 轮流值班默认选择周一/1天、9:00
            cycleDay: rule.cycleType !== 'CUSTOM' ? rule.cycleDay || 1 : 1,
            cycleTime: typeof rule.cycleTime === 'undefined' ? 32400000 : rule.cycleTime,
            cycleDayForCustom: rule.cycleType === 'CUSTOM' ? rule.cycleDay : 1,
            ruleAtList: [rule.ruleStartAt, rule.ruleEndAt]
        };
    }
    onSuccess(ruleDateType) {
        this.getRules(ruleDateType.toUpperCase());
    }
    get operations() {
        return [
            {
                label: '编辑',
                action: 'edit',
                props: {
                    class: 'table-link'
                },
                click: (action: string, scope: any) => {
                    this.ruleData = { ...scope.row };
                    this.modalType = 'update';
                    this.ruleDateType = scope.row.ruleDateType.toLowerCase();
                    this.showModal = true;
                }
            },
            {
                label: '删除',
                action: 'delete',
                props: {
                    class: 'table-link'
                },
                click: (action: string, scope: any) => {
                    this.$mtd
                        .confirm({
                            title: '是否确认删除该规则？',
                            width: '433px',
                            showCancelButton: true,
                            type: 'warning',
                            okButtonText: '删除',
                            className: 'common-modal',
                            okButtonProps: {
                                type: 'danger',
                                class: 'tt-pure-btn'
                            },
                            cancelButtonProps: {
                                class: 'tt-pure-btn'
                            },
                            onOk: async () => {
                                try {
                                    const res = await api.oncallApi.deleteRgRule(scope.row.id);
                                    const { code } = res;
                                    if (code === 200) {
                                        this.$mtd.message({
                                            message: '删除规则成功',
                                            type: 'success'
                                        });
                                        this.getRules(scope.row.ruleDateType);
                                    }
                                } catch (e) {
                                    console.log(e);
                                }
                            }
                        })
                        .catch(e => e);
                }
            }
        ];
    }
    get rgId() {
        return parseInt(this.$route.query.rgId as string, 10);
    }
}
